import { FloatingServiceMenu, Footer, Header, Page, PageTransition } from '@components/Page'
import { pickSeoProps } from '@components/Page/Page'
import ContentBlocks from '@components/_content-page/ContentBlocks'
import { getDataCodenameValues } from '@lib/getDataCodenameValues'
import { SingleItemResponse } from '@lib/kontent'
import { ContentPage as ContentPageModel } from '@lib/kontent/models/ContentPage'
import { FC } from 'react'

type Props = SingleItemResponse<ContentPageModel>

const ContentPage: FC<Props> = ({ item, modular_content }) => {
  const keys = getDataCodenameValues(item.elements.content_blocks.value)
  const contentBlocks = keys.map((key) => ({
    type: modular_content[key].system.type,
    elements: modular_content[key].elements,
  }))
  return (
    <Page {...pickSeoProps(item.elements)}>
      <FloatingServiceMenu />
      <Header initialVariant="absolute" />
      <PageTransition>
        <ContentBlocks contentBlocks={contentBlocks} modularContent={modular_content} />
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default ContentPage
